module.exports = __webpack_public_path__ + "static/media/LogoLogin.1788849a.png";